import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-icon",
  "use": "icon-close-icon-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close-icon\">\n<rect x=\"1.33105\" y=\"1\" width=\"27.3333\" height=\"27.3333\" fill=\"black\" stroke=\"#A7F900\" stroke-width=\"2\" />\n<line x1=\"27.4395\" y1=\"2.17317\" x2=\"2.5062\" y2=\"27.1065\" stroke=\"#A7F900\" stroke-width=\"2\" />\n<line x1=\"2.50398\" y1=\"2.22527\" x2=\"27.4373\" y2=\"27.1586\" stroke=\"#A7F900\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol